<template>
  <Header height="50px">
    <div class="brand">
      <svgicon name="Tpando" width="32" height="32" :original="true"></svgicon>
      <h1>{{currentTransporter && currentTransporter.name}} - {{title}}</h1>
    </div>
    <span v-if="this.$hasFeature('payments_v2')">
      <Link :underline="false" @click="$emit('openDialog')">
        <svgicon name="newnotification" width="15" height="20" :original="true"></svgicon>
      </Link>
    </span>
  </Header>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      currentTransporter: 'app/currentTransporter',
    }),
    title() {
      const title = this.$route.meta.title;
      return title || '';
    },
  },
  methods: {
    openPopup() {
      this.$emit('openDialog');
    },
  },
};
</script>
<style scoped lang="scss">
$fontSemibold: 'OpenSans-Semibold';

  .header {
    height: 50px;
    background: #234357;
    padding-top: 10px;
    z-index: 1;
    .account-name {
      display: inline-block;
      color: #fff;
      font-family:$fontSemibold;
      font-size: 1.6rem;
      margin: 4px 0;
      padding-left: 13px;
      position: relative;
      top: 2px;
      border-left: 1px solid #55798c;
      margin-left: 10px;
    }
  }
</style>
